module.exports = __webpack_public_path__ + "img/chengse.393a62d9.png";